import { NgModule } from '@angular/core';
import { TagComponent } from './tag/tag.component';
import { TagsComponent } from './tags.component';
import { SharedModule } from '../../shared/shared.module';
import { SeparatorComponent } from '@exl-ng/mulo-common';

@NgModule({
    imports: [SharedModule, SeparatorComponent, TagComponent, TagsComponent],
    exports: [TagComponent, TagsComponent],
})
export class TagsModule {}
